export default "__VITE_ASSET__DvijAIZL__"